import { Link } from "react-router-dom";
import { Migalhas as Nav } from "./styled";

/**
 * Trilha "Conteúdo › Espécies › Nova espécie". O último item é a página atual
 * (aria-current); os demais são links de volta.
 * `itens`: [{ rotulo, para? }] — sem `para` é a página atual.
 */
export default function Migalhas({ itens }) {
  return (
    <Nav aria-label="Você está em">
      <ol>
        {itens.map((item, i) => (
          <li key={`${item.rotulo}-${i}`}>
            {item.para
              ? <Link to={item.para}>{item.rotulo}</Link>
              : <span aria-current="page">{item.rotulo}</span>}
          </li>
        ))}
      </ol>
    </Nav>
  );
}
